const currentVersion = {"dev1":"0.0.38","staging":"0.0.6","prod":"0.0.280"}
module.exports = { currentVersion }